import { useState } from 'react';

import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab3 = ({ alldata, isLoading }) => {
  return (
    <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">More Information</p>
      </div>

      <div className="col-6 ">
        <div className={ `mb-3`}>
           <Input
            id="Company"
            readOnly
            label="Company"
            style={{
              height: "30px",
             
            }}
            value={alldata?.company || ""}
          />
         
        
         
        </div>
      </div>

      <div className="col-6">
       <div className={ `mb-3`}>
         <Input
            id="WorkOrder"
            readOnly
            label="WorkOrder"
            style={{
              height: "30px",
            
            }}
            value={alldata?.work_order || ""}
          />

         
        </div>
      </div>
    </div>
  );
};

export default Tab3;